import './styles.scss';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, browserHistory } from 'react-router';
import { loadStripe } from '@stripe/stripe-js';

import { getRouteByName } from 'Helpers/Routes';

import Form from 'Components/forms/Form';
import Input from 'Components/forms/Input';
import Button from 'Components/layout/Button';
import FormErrorMessage from 'Components/forms/helpers/FormErrorMessage';

import FacebookEmailRejectedForm from 'Components/user/FacebookEmailRejectedForm';
import FacebookPermissionsRejectedForm from 'Components/user/FacebookPermissionsRejectedForm';

import { login as facebookLogin } from 'Redux/actions/facebook';
import { signUp, signUpFacebook } from 'Redux/actions/user';
import { addNotification } from 'Redux/actions/global';

@connect(
    (state) => ({
        user: state.user,
        facebook: state.facebook
    }),
    {
        signUp, signUpFacebook, facebookLogin, addNotification
    }
)
export default class SignUpForm extends Component {
    static propTypes = {
        signUp: PropTypes.func.isRequired,
        signUpFacebook: PropTypes.func.isRequired,
        facebookLogin: PropTypes.func.isRequired,
        addNotification: PropTypes.func.isRequired,
        user: PropTypes.shape({
            isSignupPending: PropTypes.bool.isRequired,
            signupErrors: PropTypes.array.isRequired,
            accessToken: PropTypes.string,
            profile: PropTypes.object
        }).isRequired,
        facebook: PropTypes.shape({
            isInitialized: PropTypes.bool.isRequired
        }).isRequired,
        location: PropTypes.shape({
            search: PropTypes.string
        }).isRequired,
        onRedirectToSignIn: PropTypes.func
    };

    initialFormState = {
        email: '',
        terms_of_service: true
    };

    state = {
        currentStep: 'default',
        fbResponse: null,
        selfServing: false,
        smbSubscriptionId: null,
        smbSubscriptionPeriod: null,
    };

    componentDidMount = () => {
        const { location } = this.props;
        if (location.query) {
            let selfServing = false;
            let smbSubscriptionId = null;
            let smbSubscriptionPeriod = null;
            if (location.query.type === 'smb') {
                selfServing = true;
            }

            if (location.query.id) {
                smbSubscriptionId = location.query.id;
            }

            if (location.query.yearly !== undefined) {
                smbSubscriptionPeriod = location.query.yearly === "true" ? 'YEAR' : 'MONTH';
            }

            this.setState({ selfServing, smbSubscriptionId, smbSubscriptionPeriod });
        }
    }

    onSubmit = (data) => {
        const { selfServing, smbSubscriptionId, smbSubscriptionPeriod } = this.state;
        this.props.signUp({ ...data, selfServing, smbSubscriptionId, smbSubscriptionPeriod })
            .then(response => {
                const user = response && response.payload && response.payload.data && response.payload.data.user;

                if (response.state === 'SUCCESS') {
                    this.props.addNotification({
                        title: 'Account successfully created. Check your e-mail for the activation link.',
                        type: 'success'
                    });

                    if (user && user.stripeSessionId) {
                        loadStripe(process.env.STRIPE_PUBLIC_KEY).then(stripe =>  stripe.redirectToCheckout({
                            sessionId: user.stripeSessionId,
                        }));
                        
                        return user;
                    } 
                }
            });
    }


    onFacebook = (data) => {
        const { selfServing, smbSubscriptionId, smbSubscriptionPeriod } = this.state;

        this.props.facebookLogin(this.state.currentStep === 'fbPermissionsDeclined').then(response => {
            if (typeof response.authResponse === 'undefined' || typeof response.status === 'undefined') {
                return false;
            }

            let grantedScopes = response.authResponse.grantedScopes;
            grantedScopes = grantedScopes.split(',');

            if (grantedScopes.indexOf("email") === -1) {
                this.setState({
                    ...this.state,
                    fbResponse: response.authResponse,
                    currentStep: 'fbPermissionsDeclined'
                });
            } else {
                if (response.status === 'connected') {
                    if (!data) data = {};
                    let userData = Object.assign({}, response.authResponse, data);

                    this.props.signUpFacebook({ ...userData, selfServing, smbSubscriptionId, smbSubscriptionPeriod }).then(apiResponse => {
                        if (apiResponse.state === 'FAIL') {
                            let emailErrorFound = false;

                            if (apiResponse.payload && apiResponse.payload.errors && apiResponse.payload.errors.length) {
                                apiResponse.payload.errors.forEach(error => {
                                    if (error.field === 'email') emailErrorFound = true;
                                });
                            }

                            if (emailErrorFound) {
                                this.setState({
                                    ...this.state,
                                    fbResponse: response.authResponse,
                                    currentStep: 'fbEmailRejected'
                                });
                            }
                        } else if(
                            apiResponse
                            && apiResponse.payload
                            && apiResponse.payload.data
                            && apiResponse.payload.data.user
                            && apiResponse.payload.data.user.stripeSessionId
                        ) { 
                            loadStripe(process.env.STRIPE_PUBLIC_KEY).then(stripe =>  stripe.redirectToCheckout({
                                sessionId: apiResponse.payload.data.user.stripeSessionId,
                            }));
                        } else if (apiResponse.state === 'SUCCESS') {
                            browserHistory.go('/');
                            this.props.addNotification({
                                title: 'Account successfully created. Check your e-mail for the activation link.',
                                type: 'success'
                            });
                        }
                    });
                }
            }
        });
    }

    render() {
        const { selfServing } = this.state;
        const { onRedirectToSignIn } = this.props;
        const { isSignupPending, accessToken, signupErrors } = this.props.user;
        const facebook = this.props.facebook;
        const termsLabel = I18n.t('SIGNUP.form.terms.label').replace('{{link}}', getRouteByName('terms').path);

        //Override all signup errors from API to be global
        let errors = [];
        if (signupErrors.length) {
            errors = signupErrors.map((error, index) => {
                return {
                    field: 'global',
                    message: error
                };
            });
        }
        return (
            <div className="component-signup-form">
                <header className="content-header">
                    <h1>{I18n.t('SIGNUP.title')}</h1>
                </header>
                <div className="signup-inner">
                    <div className="tabs">
                        <div
                            className={`tab ${!selfServing ? 'selected' : ''} `}
                            onClick={() => this.setState({ selfServing: false })}
                        >
                            <div className="tab-txt">Creator</div>
                        </div>
                        <div
                            className={`tab ${selfServing ? 'selected' : ''} `}
                            onClick={() => this.setState({ selfServing: true })}
                        >
                            <div className="tab-txt">Business</div>
                        </div>
                    </div>
                    {this.state.currentStep === 'default' ?
                        <div className="content user-layout-content">


                            <Form
                                isLoading={isSignupPending || accessToken ? true : false}
                                isSuccess={accessToken ? true : false}
                                onSubmit={this.onSubmit}
                                className="form-signup"
                                errors={signupErrors}
                                initialState={this.initialFormState}
                            >
                                <Input
                                    type="email"
                                    name="email"
                                    placeholder={I18n.t('SIGNUP.form.email.placeholder')}
                                    roleName="input"
                                    required={true}
                                    autocomplete="email"
                                />
                                <FormErrorMessage roleName="formErrorMessage" />
                                <div className="form-footer">
                                    <Button type="submit" layout="full-width"><span>{I18n.t('SIGNUP.form.button.label')}</span></Button>
                                    <span className="type-divider">{I18n.t('SIGNUP.form.typeDivider')}</span>
                                    <Button layout="full-width" element="anchor" styleType="facebook" disabled={!facebook.isInitialized} onClick={this.onFacebook}>
                                        <img src={require('Theme/images/icons/icon-fb-white.png')} />
                                        <span>{I18n.t('SIGNUP.form.fbButton.label')}</span>
                                    </Button>
                                    {
                                        this.state.facebookPermissionsDeclined ?
                                            <span className="form-message">{I18n.t('SIGNIN.form.fbButton.permissionError')}
                                                <a onClick={this.onFacebook}>{I18n.t('SIGNIN.form.fbButton.permissionCta')}</a>
                                            </span> : ''
                                    }
                                    <span className="terms-agree" dangerouslySetInnerHTML={{ __html: termsLabel }}></span>
                                </div>
                            </Form>
                            <footer className="content-footer">
                                <span>{I18n.t('SIGNUP.form.goToSignin')}{' '}
                                    <Link
                                        to={onRedirectToSignIn ? null : getRouteByName('signIn').path}
                                        className="link highlighted bold"
                                        onClick={onRedirectToSignIn || null}
                                    >
                                        {I18n.t('SIGNUP.form.goToSigninLink')}
                                    </Link>
                                </span>
                            </footer>
                        </div>
                        : null}
                    {this.state.currentStep === 'fbEmailRejected' ?
                        <div className="content user-layout-content">
                            <FacebookEmailRejectedForm
                                isLoading={isSignupPending}
                                onSubmit={this.onFacebook}
                            />
                        </div>
                        : null}
                    {this.state.currentStep === 'fbPermissionsDeclined' ?
                        <div className="content user-layout-content">
                            <FacebookPermissionsRejectedForm
                                onSubmit={this.onFacebook}
                            />
                        </div>
                        : null
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/user/SignupForm/index.js